module.exports = __webpack_public_path__ + "static/media/game-background.79c66246.jpg";